import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumbs from '../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Methods of purchasing property</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs crumbs={[{ url: '/ways-to-purchase', name: 'Ways to purchase' }]} />
                <h2 className="lead text-center">Different methods of buying and selling property</h2>
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    ​
                    <p>
                      There are several methods of buying and selling property in New Zealand. Each is fairly different
                      so its important to learn all of the ins and outs.
                    </p>
                    <hr />
                    <h4>
                      <a href="/ways-to-purchase/advertised-price">
                        Buying and selling at an <strong>advertised price</strong>
                      </a>
                    </h4>
                    <p>
                      This is when the property is marketed with a selling price – the amount the seller wants to be
                      paid for it.
                    </p>
                    <p>
                      <a href="/ways-to-purchase/advertised-price">Read more here</a>
                    </p>
                    <hr />
                    <h4>
                      <a href="/ways-to-purchase/auctions">
                        Buying and selling by <strong>auction</strong>
                      </a>
                    </h4>
                    <p>An auction is an open process where buyers bid against one another to purchase a property.</p>
                    <p>
                      <a href="/ways-to-purchase/auctions">Read more here</a>
                    </p>
                    <hr />
                    <h4>
                      <a href="/ways-to-purchase/deadline-sale">
                        Buying and selling by <strong>deadline sale</strong>
                      </a>
                    </h4>
                    <p>
                      When a property is sold by deadline sale, it is marketed for a set period with an advertised end
                      date.{' '}
                    </p>
                    <p>
                      <a href="/ways-to-purchase/deadline-sale">Read more here</a>
                    </p>
                    <hr />
                    <h4>
                      <a href="/ways-to-purchase/negotiation">
                        Buying and selling by <strong>negotiation</strong>
                      </a>
                    </h4>
                    <p>
                      A seller may choose to sell by negotiation when it’s difficult to estimate the market price of a
                      property. There is no end date for offers. Buyers make offers based on what they think the
                      property is worth in the current market
                    </p>
                    <p>
                      <a href="/ways-to-purchase/negotiation">Read more here</a>
                    </p>
                    <hr />
                    <h4>
                      <a href="/ways-to-purchase/tender">
                        Buying and selling by <strong>tender</strong>
                      </a>
                    </h4>
                    <p>
                      When a property is being sold by tender prospective buyers submit confidential written offers for
                      the property to the agent.
                    </p>
                    <p>
                      <a href="/ways-to-purchase/tender">Read more here</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/WaysToPurchase.jsx